import { AuthenticatedUser, UpdatePasswordForm } from '../../models';

export class ClearAuthStateSubscription {
  static readonly type = '[User] Clear Auth State Subscription';
}

export class FetchIpAddress {
  static readonly type = '[User] Fetch IP Address';
}

export class FetchPortalUser {
  static readonly type = "[User] Fetch Patient's User";
}

export class InitUser {
  static readonly type = '[User] Initializing User State';
}

export class ResetState {
  static readonly type = '[User] Reset state';
}

export class ResetUser {
  static readonly type = '[User] Reset user state';
}

export class SetAgentAuthValues {
  static readonly type = '[User] Set Agent Auth Values';
  constructor(public token: string) {}
}

export class SetAuthenticatedUser {
  static readonly type = '[User] Set Authenticated User Value';
  constructor(public authenticatedUser: AuthenticatedUser | null) {}
}

export class SetUserSignInFlag {
  static readonly type = '[User] Set New User SignIn Flag';
  constructor(public value: boolean) {}
}

export class SignInTestPatient {
  static readonly type = '[User] Sign In Test Patient';
  constructor(public token: string) {}
}

export class SignOut {
  static readonly type = '[User] Sign Out';
  constructor(public options?: { sessionExpired: boolean }) {}
}

export class SwitchPatient {
  static readonly type = '[User] Switch Patient';
  constructor(public patientId: number) {}
}

export class UpdatePassword {
  static readonly type = '[User] Update Password';
  constructor(public formValues: UpdatePasswordForm) {}
}

export class SetIsActivating {
  static readonly type = '[User] Set Is Activating';
  constructor(public values: boolean) {}
}

export class ActivateUser {
  static readonly type = '[User] Activate User';
  constructor() {}
}

export class verifyActivationToken {
  static readonly type = '[User] Verify Email';
  constructor(public token: string) {}
}

export class resendActivationEmail {
  static readonly type = '[User] Resend Activation Email';
  constructor(public token: string) {}
}

export class createUserFromEmail {
  static readonly type = '[User] Send Activation Email';
  constructor(public email: string) {}
}
